import gql from 'graphql-tag';

export class FormInput {
  id: number;
  name: string;
  companyVat: string;
  companyTaxOffice: string;
  gemiNumber: string;
  imaCode: string;
  ymeCode: string;
  addressDescription: string;
  addressLine1: string;
  addressLine2: string;
  addressArea: string;
  addressCity: string;
  addressNomos: string;
  postalCode: string;
  phone: string;
  mobile: string;
  fax: string;
  email: string;
  contactPerson: string;
  categoryId: number;
  regionId: number;
  subregionId: number;
  groupId: number;
  subgroupId: number;
  subsubgroupId: number;
  isPubliclyVisibleInMap: boolean;
  recordDate: Date;
  legacyAppId: string;
  isActive: boolean;
  firstDate: Date;
  lastDate: Date;
  firstUser: string;
  lastUser: string;
  longitude: number;
  latitude: number;
  gpsUpdateId: number;
  gpsDate: Date;
  gpsSource: string;
  notes: string;

  constructor() {
    this.id = undefined;
    this.name = undefined;
    this.companyVat = undefined;
    this.companyTaxOffice = undefined;
    this.gemiNumber = undefined;
    this.imaCode = undefined;
    this.ymeCode = undefined;
    this.addressDescription = undefined;
    this.addressLine1 = undefined;
    this.addressLine2 = undefined;
    this.addressArea = undefined;
    this.addressCity = undefined;
    this.addressNomos = undefined;
    this.postalCode = undefined;
    this.phone = undefined;
    this.mobile = undefined;
    this.fax = undefined;
    this.email = undefined;
    this.contactPerson = undefined;
    this.categoryId = undefined;
    this.regionId = undefined;
    this.subregionId = undefined;
    this.groupId = undefined;
    this.subgroupId = undefined;
    this.subsubgroupId = undefined;
    this.isPubliclyVisibleInMap = undefined;
    this.recordDate = undefined;
    this.legacyAppId = undefined;
    this.isActive = undefined;
    this.firstDate = undefined;
    this.lastDate = undefined;
    this.firstUser = undefined;
    this.lastUser = undefined;
    this.longitude = undefined;
    this.latitude = undefined;
    this.gpsUpdateId = undefined;
    this.gpsDate = undefined;
    this.gpsSource = undefined;
    this.notes = undefined;
  }
}

export const gqlGetQuery = gql`
  query getCollectionpoints($limit: Int, $offset: Int, $order: String, $where: String) {
    getCollectionpoints(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        code
        name
        companyVat
        companyTaxOffice
        gemiNumber
        imaCode
        ymeCode
        addressDescription
        addressLine1
        addressLine2
        addressArea
        addressCity
        addressNomos
        postalCode
        phone
        mobile
        fax
        email
        contactPerson
        regionId
        subregionId
        groupId
        subgroupId
        subsubgroupId
        isPubliclyVisibleInMap
        recordDate
        legacyAppId
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
        cpGroup {
          id
          name
        }
        region {
          id
          name
        }
        notes
        region {
          id
          name
        }
        subregion {
          id
          name
        }
        category {
          id
          name
        }
        collectionpointsWasteCategories {
          id
          cpWasteCategoryId
          cpWasteCategory {
            id
            name
          }
        }
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getCollectionpointById($id: Int) {
    getCollectionpointById(id: $id) {
      id
      name
      companyVat
      companyTaxOffice
      gemiNumber
      imaCode
      ymeCode
      addressDescription
      addressLine1
      addressLine2
      addressArea
      addressCity
      addressNomos
      code
      notes
      addressDistrict
      latitude
      longitude
      gpsDate
      gpsSource
      gpsUpdateId
      gpsUpdateType {
        id
        name
      }
      customField1
      postalCode
      phone
      mobile
      fax
      email
      contactPerson
      categoryId
      groupId
      subgroupId
      subsubgroupId
      isPubliclyVisibleInMap
      recordDate
      legacyAppId
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
      regionId
      region {
        id
        name
      }
      subregionId
      subregion {
        id
        name
      }
      professionId
      profession {
        id
        name
      }
      parentCpId
      parentCollectionpoint {
        id
        name
        legacyAppId
      }
      cpGroup {
        id
        name
      }
      cpSubgroup {
        id
        name
      }
      cpSubsubgroup {
        id
        name
      }
      collectionpointsWasteCategories {
        id
        cpWasteCategoryId
        cpWasteCategory {
          id
          name
          isActive
        }
      }
    }
  }
`;

export const gqlAdd = gql`
  mutation addCollectionpoint($data: CollectionpointInput) {
    addCollectionpoint(data: $data) {
      id
      name
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateCollectionpoint($data: CollectionpointInput) {
    updateCollectionpoint(data: $data) {
      id
      name
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteCollectionpoint($id: Int) {
    deleteCollectionpoint(id: $id)
  }
`;

export const gqlGetQueryExcelExport = gql`
  query getCollectionpoints($limit: Int, $offset: Int, $order: String, $where: String) {
    getCollectionpoints(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        code
        name
        companyVat
        companyTaxOffice
        gemiNumber
        imaCode
        ymeCode
        addressDescription
        addressLine1
        addressLine2
        addressArea
        addressCity
        postalCode
        phone
        mobile
        fax
        email
        contactPerson
        groupId
        subgroupId
        subsubgroupId
        isPubliclyVisibleInMap
        recordDate
        legacyAppId
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
        cpGroup {
          id
          name
        }
        parentCpId
        parentCollectionpoint {
          id
          name
          legacyAppId
        }
        notes
        collectionpointsWasteCategories {
          id
          cpWasteCategoryId
          cpWasteCategory {
            id
            name
          }
        }
        category {
          id
          name
        }
      }
      recordCount
    }
  }
`;
